import React from 'react';
import { DatePicker } from 'react-datepickers';

import withTranslatePlaceholder from 'components/hocs/withTranslatePlaceholder';
import withFieldWrapper from 'components/hocs/withFieldWrapper';

const LocalizedDatepicker = withTranslatePlaceholder(DatePicker);

const DatepickerComponent = ({ ...props }) => (
    <LocalizedDatepicker placeholder="placeholders.datepicker" {...props} />
);

export default withFieldWrapper(DatepickerComponent);
